module.exports = __webpack_public_path__ + "static/media/5.d3a90ada.webp";